// extracted by mini-css-extract-plugin
export default {"container":"micromag_container__1NOrx","footer":"micromag_footer__gtFQ9","cta":"micromag_cta__1fx4v"};